<template>
  <el-dialog width="520px" title="查看详情"  :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="productDetailVisible"  append-to-body>
    <div class="details" v-loading="loading">
      <el-form  ref="currencyForm"  size="small"   label-position="top"  >
        <el-row  type="flex" style="flex-wrap: wrap">

          <el-col :span="12" >
            <el-form-item prop="" label="产品名称">
              <div class="filed_value" v-text="productDetail.product ? productDetail.product.product_name : ''"></div>
            </el-form-item>
          </el-col>

          <el-col :span="12" >
            <el-form-item prop="" label="激活码">
              <div class="filed_value" v-text="productDetail.license_code ? productDetail.license_code : ''"></div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="" label="购买时间">
              <div class="filed_value" v-text="productDetail.order ? convertToCurrentTimezone(productDetail.order.pay_date,'/','datetime') : ''"></div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="" label="订单号">
              <div class="filed_value" v-text="productDetail.order ? productDetail.order.order_num : ''"></div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="" label="当前状态">
              <div class="filed_value" v-text="productDetail.machine_id ? '已激活' : '未激活'"></div>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="" label="有效期截止日">
              <div class="filed_value" v-if="productDetail.order && productDetail.order.start_date" v-text="convertToCurrentTimezone(productDetail.order.start_date,'/','datetime') +' ~ '+ convertToCurrentTimezone(productDetail.order.end_date,'/','datetime')"></div>
            </el-form-item>
          </el-col>

          <div class="line"></div>

          <el-col :span="24">
            <el-form-item prop="" label="模块信息">
              <div class="filed_value">
                <p v-for="item in productDetail.license_modules">
                  <span v-text="item.module ? item.module.module_name : ''"></span> :
                  <span v-text="item.module_value ? item.module_value : ''"></span>
                </p>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>

    </div>

  </el-dialog>
</template>
<script>

import {mapState} from "vuex";
import {convertToCurrentTimezone} from '@/utils'
import {productDetail} from '@/api/api'
export default {
  name: 'product_detail',
  props: {
    productDetailVisible: {
      type: Boolean,
      default: false,
    },
    productId: {
      type: Number,
      default: 0,
    },
  },
  data() {

    return {
      loading:false,
      BtnDisabled: false,
      productDetail:{}
    }
  },

  created() {
    if(this.productId){
      this.getAdminProductDetail()
    }
  },
  computed: {
    ...mapState(['adminUserInfo']),

  },
  mounted() {

  },
  methods: {
    convertToCurrentTimezone(utcTime,separator,type) {
      return convertToCurrentTimezone(utcTime,separator,type);
    },
    // 获取
    getAdminProductDetail(){
      this.loading = true
      let postData = {
        id:this.productId,
      }
      productDetail(postData).then(res => {
        if (res.code === 200) {
          let {data} = res
          this.productDetail = data
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:productDetailVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.mt-15{
  margin-top: 15px;
}
.el-select{
  display: block;
}
.details{
  width: 100%;
}
::v-deep .el-form-item__label{
  padding-bottom: 0;
  color: rgba(51, 51, 51, 1);
}
.filed_value{
  line-height: 20px;
  color: rgba(102, 102, 102, 1);
}
.line{
  width: 100%;
  height: 1px;
  background: rgba(217, 217, 217, 1);
  margin-bottom: 10px;
}
</style>
